import { render, staticRenderFns } from "./FareOption.vue?vue&type=template&id=851290f8&scoped=true&"
import script from "./FareOption.vue?vue&type=script&lang=js&"
export * from "./FareOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851290f8",
  null
  
)

export default component.exports